// Knights Four Data - Group Four (Exotic & International Knights)

// Sir Tor the Bastard's workout programs
const torPrograms = [
    {
        id: 'bastard-knight-training',
        name: 'Bastard Knight Training',
        description: 'Proving-ground conditioning for those who must earn their place through merit',
        pattern: '];+*x&',
        reps: 15,
        sets: 4,
        focus: 'Merit Proving'
    },
    {
        id: 'golden-sun-conditioning',
        name: 'Golden Sun Conditioning',
        description: 'Radiant strength training that shines despite humble origins',
        pattern: '*];+&x',
        reps: 17,
        sets: 4,
        focus: 'Radiant Merit'
    },
    {
        id: 'white-and-gold-protocol',
        name: 'White and Gold Protocol',
        description: 'Pure conditioning that transforms illegitimate birth into noble purpose',
        pattern: 'x&+]*;',
        reps: 14,
        sets: 5,
        focus: 'Noble Purpose'
    },
    {
        id: 'pellimore-legacy-strength',
        name: 'Pellimore Legacy Strength',
        description: 'Bloodline conditioning that honors the father\'s hunting prowess',
        pattern: '+;]*&x',
        reps: 19,
        sets: 3,
        focus: 'Hunter Heritage'
    },
    {
        id: 'young-eager-training',
        name: 'Young Eager Training',
        description: 'Enthusiastic conditioning that burns with determination to prove worth',
        pattern: ']];;++',
        reps: 21,
        sets: 3,
        focus: 'Determined Youth'
    },
    {
        id: 'earned-honor-mastery',
        name: 'Earned Honor Mastery',
        description: 'The complete training for those who achieve greatness through their own efforts',
        pattern: '];+*x&!!',
        reps: 23,
        sets: 3,
        focus: 'Self-Made Honor'
    }
];

// Sir Agravaine the Proud's workout programs
const agravainePrograms = [
    {
        id: 'proud-knight-training',
        name: 'Proud Knight Training',
        description: 'Arrogant conditioning that demands recognition and superiority',
        pattern: '({)*-&',
        reps: 16,
        sets: 4,
        focus: 'Superior Pride'
    },
    {
        id: 'purple-gold-conditioning',
        name: 'Purple and Gold Conditioning',
        description: 'Royal color strength that displays noble arrogance',
        pattern: '&({)*-',
        reps: 18,
        sets: 3,
        focus: 'Royal Arrogance'
    },
    {
        id: 'golden-crown-protocol',
        name: 'Golden Crown Protocol',
        description: 'Imperial conditioning for those who believe they deserve to rule',
        pattern: '*-&({)',
        reps: 13,
        sets: 6,
        focus: 'Imperial Ambition'
    },
    {
        id: 'imperious-bearing-strength',
        name: 'Imperious Bearing Strength',
        description: 'Commanding presence training that looks down upon all others',
        pattern: ')({-*&',
        reps: 20,
        sets: 3,
        focus: 'Commanding Disdain'
    },
    {
        id: 'gawain-brother-training',
        name: 'Gawain Brother Training',
        description: 'Orkney bloodline conditioning enhanced by prideful competitiveness',
        pattern: '(())--',
        reps: 22,
        sets: 3,
        focus: 'Competitive Pride'
    },
    {
        id: 'pride-mastery-conditioning',
        name: 'Pride Mastery Conditioning',
        description: 'The ultimate training for the most arrogant knight of the Round Table',
        pattern: '({)*-&!!',
        reps: 25,
        sets: 3,
        focus: 'Ultimate Arrogance'
    }
];

// Sir Safir the Saracen's workout programs
const safirPrograms = [
    {
        id: 'eastern-knight-training',
        name: 'Eastern Knight Training',
        description: 'Exotic conditioning that blends Saracen and Western fighting techniques',
        pattern: '|<}:-*',
        reps: 14,
        sets: 5,
        focus: 'Eastern Fusion'
    },
    {
        id: 'damascus-steel-conditioning',
        name: 'Damascus Steel Conditioning',
        description: 'Superior metallurgy strength training with folded steel techniques',
        pattern: '*|<}:-',
        reps: 16,
        sets: 4,
        focus: 'Steel Mastery'
    },
    {
        id: 'crimson-silk-protocol',
        name: 'Crimson Silk Protocol',
        description: 'Elegant Eastern conditioning wrapped in the finest Saracen silks',
        pattern: ':-*|<}',
        reps: 17,
        sets: 4,
        focus: 'Eastern Elegance'
    },
    {
        id: 'geometric-pattern-strength',
        name: 'Geometric Pattern Strength',
        description: 'Mathematical conditioning based on Islamic geometric principles',
        pattern: '}:-|*<',
        reps: 15,
        sets: 5,
        focus: 'Sacred Geometry'
    },
    {
        id: 'arabian-stallion-training',
        name: 'Arabian Stallion Training',
        description: 'Desert mount conditioning for the finest horses of the East',
        pattern: '||<<}}',
        reps: 19,
        sets: 3,
        focus: 'Desert Endurance'
    },
    {
        id: 'palamedes-brother-mastery',
        name: 'Palamedes Brother Mastery',
        description: 'The complete Eastern training that bridges two worlds of knighthood',
        pattern: '|<}:-*!!',
        reps: 21,
        sets: 3,
        focus: 'Bridge Builder'
    }
];

// Sir Segwarides the Jealous's workout programs
const segwaridesPrograms = [
    {
        id: 'jealous-knight-training',
        name: 'Jealous Knight Training',
        description: 'Suspicious conditioning fueled by mistrust and burning envy',
        pattern: '>+;-*&',
        reps: 13,
        sets: 6,
        focus: 'Burning Envy'
    },
    {
        id: 'serpent-shield-conditioning',
        name: 'Serpent Shield Conditioning',
        description: 'Venomous strength training that strikes with jealous fury',
        pattern: '&>+;-*',
        reps: 18,
        sets: 4,
        focus: 'Venomous Strike'
    },
    {
        id: 'dark-green-protocol',
        name: 'Dark Green Protocol',
        description: 'Envious conditioning that feeds on the success of others',
        pattern: '*-;&>+',
        reps: 16,
        sets: 4,
        focus: 'Envious Fuel'
    },
    {
        id: 'watchful-eye-strength',
        name: 'Watchful Eye Strength',
        description: 'Paranoid conditioning that sees threats and rivals everywhere',
        pattern: '+;->*&',
        reps: 20,
        sets: 3,
        focus: 'Paranoid Vigilance'
    },
    {
        id: 'dark-bay-training',
        name: 'Dark Bay Training',
        description: 'Suspicious mount conditioning for horses that share their master\'s mistrust',
        pattern: '>>++;;',
        reps: 22,
        sets: 3,
        focus: 'Shared Mistrust'
    },
    {
        id: 'jealousy-mastery-conditioning',
        name: 'Jealousy Mastery Conditioning',
        description: 'The complete training that transforms jealousy into terrible power',
        pattern: '>+;-*&!!',
        reps: 24,
        sets: 3,
        focus: 'Jealous Power'
    }
];

// Sir Dodinas le Savage's workout programs
const dodinasPrograms = [
    {
        id: 'wild-knight-training',
        name: 'Wild Knight Training',
        description: 'Borderland conditioning from the savage edges of civilization',
        pattern: '}*-+&>',
        reps: 17,
        sets: 4,
        focus: 'Wild Frontier'
    },
    {
        id: 'wolf-pack-conditioning',
        name: 'Wolf Pack Conditioning',
        description: 'Pack hunting strength training inspired by border wolves',
        pattern: '>}*-+&',
        reps: 19,
        sets: 3,
        focus: 'Pack Hunter'
    },
    {
        id: 'fur-and-leather-protocol',
        name: 'Fur and Leather Protocol',
        description: 'Primitive conditioning using natural materials over refined armor',
        pattern: '&+->*}',
        reps: 21,
        sets: 3,
        focus: 'Primitive Power'
    },
    {
        id: 'mountain-pony-strength',
        name: 'Mountain Pony Strength',
        description: 'Hardy conditioning for rough terrain and savage conditions',
        pattern: '-+}>&*',
        reps: 16,
        sets: 4,
        focus: 'Savage Endurance'
    },
    {
        id: 'borderland-survival-training',
        name: 'Borderland Survival Training',
        description: 'Wilderness conditioning that thrives in the harshest environments',
        pattern: '}}**++',
        reps: 23,
        sets: 3,
        focus: 'Wilderness Mastery'
    },
    {
        id: 'savage-mastery-conditioning',
        name: 'Savage Mastery Conditioning',
        description: 'The ultimate wild training for knights who reject civilized weakness',
        pattern: '}*-+&>!!',
        reps: 26,
        sets: 3,
        focus: 'Wild Rejection'
    }
];

// Sir Brandiles the Bold's workout programs
const brandilesPrograms = [
    {
        id: 'bold-knight-training',
        name: 'Bold Knight Training',
        description: 'Fearless conditioning that charges headlong into any danger',
        pattern: '=>[*&+',
        reps: 18,
        sets: 4,
        focus: 'Fearless Charge'
    },
    {
        id: 'raven-feather-conditioning',
        name: 'Raven Feather Conditioning',
        description: 'Dark bird strength training that embodies cunning and courage',
        pattern: '+=[>*&',
        reps: 20,
        sets: 3,
        focus: 'Raven Cunning'
    },
    {
        id: 'orange-black-protocol',
        name: 'Orange and Black Protocol',
        description: 'Bold color conditioning that displays fearless warrior spirit',
        pattern: '*&+=[>',
        reps: 15,
        sets: 5,
        focus: 'Bold Display'
    },
    {
        id: 'war-hammer-strength',
        name: 'War Hammer Strength',
        description: 'Heavy weapon conditioning for crushing blows and battlefield dominance',
        pattern: '>=[*+&',
        reps: 22,
        sets: 3,
        focus: 'Crushing Power'
    },
    {
        id: 'battle-scarred-training',
        name: 'Battle-Scarred Training',
        description: 'Veteran conditioning marked by countless combats and hard-won victories',
        pattern: '==>>[*',
        reps: 24,
        sets: 3,
        focus: 'Veteran Scars'
    },
    {
        id: 'undaunted-mastery-conditioning',
        name: 'Undaunted Mastery Conditioning',
        description: 'The complete training for a knight who has never known retreat',
        pattern: '=>[*&+!!',
        reps: 27,
        sets: 3,
        focus: 'Never Retreat'
    }
];

// Main Knights Four trainers data object - Group Four
const knightsFourTrainersData = {
    'sir-tor-the-bastard': {
        id: 'sir-tor-the-bastard',
        name: 'Sir Tor the Bastard',
        title: 'Son of King Pellimore',
        specialization: 'Merit-Based Combat & Self-Proving',
        image: '/assets/images/Sir-Tor-the-Bastard.jpg',
        experience: '22+ years',
        category: 'knights-four',
        color: '#FFFFFF',
        secondaryColor: '#FFD700',
        intro: `The bastard son of King Pellimore who earned his place at the Round Table through pure merit rather than birth. His white and gold surcoat bears the golden sun, symbolizing his determination to shine despite humble origins. His training proves that true nobility comes from within and that those who must earn their honor often value it most.`,
        programs: torPrograms
    },
    'sir-agravaine-the-proud': {
        id: 'sir-agravaine-the-proud',
        name: 'Sir Agravaine the Proud',
        title: 'The Arrogant Brother',
        specialization: 'Superior Combat & Prideful Dominance',
        image: '/assets/images/Sir-Agravaine-the-Proud.jpg',
        experience: '38+ years',
        category: 'knights-four',
        color: '#800080',
        secondaryColor: '#FFD700',
        intro: `Gawain's brother known for his overwhelming pride and belief in his own superiority. His ornate purple and gold surcoat displays his royal pretensions, while his golden crown crest shows his imperial ambitions. His training channels arrogance into devastating effectiveness, proving that sometimes pride can be a source of terrible strength.`,
        programs: agravainePrograms
    },
    'sir-safir-the-saracen': {
        id: 'sir-safir-the-saracen',
        name: 'Sir Safir the Saracen',
        title: 'Brother to Palamedes',
        specialization: 'Eastern Combat & Cultural Fusion',
        image: '/assets/images/Sir-Safir-the-Saracen.jpg',
        experience: '33+ years',
        category: 'knights-four',
        color: '#DC143C',
        secondaryColor: '#C0C0C0',
        intro: `Brother to the great Palamedes, Safir brings the refined martial traditions of the East to Western knighthood. His crimson silk surcoat decorated with geometric patterns reflects his Saracen heritage, while his Damascus steel weapons represent superior Eastern craftsmanship. His training bridges two worlds of combat mastery.`,
        programs: safirPrograms
    },
    'sir-segwarides-the-jealous': {
        id: 'sir-segwarides-the-jealous',
        name: 'Sir Segwarides the Jealous',
        title: 'The Mistrustful Knight',
        specialization: 'Paranoid Combat & Suspicious Warfare',
        image: '/assets/images/Sir-Segwarides-the-Jealous.jpg',
        experience: '29+ years',
        category: 'knights-four',
        color: '#006400',
        secondaryColor: '#2F2F2F',
        intro: `Consumed by jealousy and mistrust, Segwarides sees rivals and threats everywhere he looks. His deep green surcoat and serpent shield reflect his venomous nature, while his constantly watchful eyes never rest. His training shows how jealousy, properly channeled, can become a source of relentless vigilance and striking power.`,
        programs: segwaridesPrograms
    },
    'sir-dodinas-le-savage': {
        id: 'sir-dodinas-le-savage',
        name: 'Sir Dodinas le Savage',
        title: 'The Wild Borderland Knight',
        specialization: 'Wilderness Combat & Primitive Warfare',
        image: '/assets/images/Sir-Dodinas-le-Savage.jpg',
        experience: '35+ years',
        category: 'knights-four',
        color: '#8B4513',
        secondaryColor: '#FFFFFF',
        intro: `The wild knight from the savage borderlands who prefers wilderness to civilization. His brown surcoat decorated with white wolf heads reflects his pack mentality, while his fur and leather armor shows his rejection of courtly refinement. His training teaches that sometimes primitive strength surpasses civilized technique.`,
        programs: dodinasPrograms
    },
    'sir-brandiles-the-bold': {
        id: 'sir-brandiles-the-bold',
        name: 'Sir Brandiles the Bold',
        title: 'The Fearless Warrior',
        specialization: 'Courage Combat & Bold Warfare',
        image: '/assets/images/Sir-Brandiles-the-Bold.jpg',
        experience: '42+ years',
        category: 'knights-four',
        color: '#FF8C00',
        secondaryColor: '#000000',
        intro: `The boldest and most fearless knight of the Round Table, who has never known retreat or hesitation. His orange and black surcoat displays his bold nature, while his raven-crested helm shows his cunning courage. His training proves that true boldness comes not from the absence of fear, but from the decision to act despite it.`,
        programs: brandilesPrograms
    }
};

// Export the data
export default knightsFourTrainersData;